import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { CONTENT } from "@/content";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("slc-lang") || "es");
  const lenis = useRef(null);
  const t = CONTENT[lang];

  useEffect(() => {
    localStorage.setItem("slc-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const l = new Lenis({ duration: 1.25, smoothWheel: true });
    lenis.current = l;
    let id;
    const raf = (time) => { l.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); l.destroy(); };
  }, []);

  const go = (target) => {
    const el = target === "top" ? 0 : document.getElementById(target);
    if (lenis.current) lenis.current.scrollTo(el, { offset: -70 });
  };

  return (
    <div className="App bg-[var(--ink)]" data-testid="app-root">
      <Header t={t} lang={lang} setLang={setLang} go={go} />
      <main>
        <Hero t={t} lang={lang} />
        <Marquee items={t.marquee} />
        <About t={t} />
        <Services t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} go={go} />
    </div>
  );
}

export default App;
